"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.replaceArrayItemAtIndex = replaceArrayItemAtIndex;
var _asc = require("./asc");
function replaceArrayItemAtIndex(array, index, newValue) {
  const output = array.slice();
  output[index] = newValue;
  return output.sort(_asc.asc);
}